module.exports = __webpack_public_path__ + "img/blog-cover.e5416f38.png";